
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[slug]",
      function () {
        return require("private-next-pages/shop/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[slug]"])
      });
    }
  